/* eslint-disable no-useless-constructor */
import networkList from '../constants/networkList';
import axios from 'axios';
import { Modal } from 'antd';
import Storage from './local-store';

const { base_url } = networkList;

const HttpClient = axios.create({
    baseURL: base_url,
    headers: {
        'Content-Type': 'application/json',
        "accept": "application/json"
    }
});
export default function postService(url, method, data) {
    const token = JSON.parse(Storage.get('token'));
    return HttpClient({
        method: method,
        url: url,
        data: data,
        headers: {
            'authorization': token
        }
    }).then(function (response) {
        const { data } = response;
        const { status } = response;
        if (status === 200) {
            if (data.status) {
                return data;
            } else {
                // Modal.error({title: data.message});
                return data;
            }
        } else if (status === 401) {
            Modal.error({
                'title': "Unauthorised Access",
                'content': `${data.message}`,
                onOk: () => {
                    localStorage.clear();
                    window.location.replace('/');
                }
            })
        } else {
            return false;
        }
    }).catch(async function (error) {
      
        let { status, data } = error.response ? error.response : {};
        if (status && status === 401) {
            Modal.error({
                'title': "Unauthorised Access",
                'content': `${data.message}`,
                onOk: () => {
                    localStorage.clear();
                    window.location.replace('/');
                }
            })
            return status
        } else {
            //Modal.error({zIndex:1600,title: error.message});
            return false;
        }


    });
}


// function logout() {
//     try {
//         const { logout } = networkList;
//         const id = JSON.parse(Storage.get('id'));
//         Modal.destroyAll();
//         this.setState({
//             "id": id,
//         })
//         this.setState((state) => ({ btnloading: true }), () => {
//             postService(logout, 'GET', {
//                 "id": this.state.id,
//             }).then(res => {
//                 if (res.status) {
//                     localStorage.clear();
//                     window.location.replace('/');
//                 } else {
//                     localStorage.clear();
//                     window.location.replace('/');
//                 }

//             })
//         });
//     } catch (error) {
//         console.log(error);
//         localStorage.clear();
//         window.location.replace('/');
//     }
// }